import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import PrintUnavailability from 'practice/components/pratice-unavailabilty/print';
import { Fragment, MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface TableUnavailabilityManagementMenuProps {
  visibility?: {
    aperturaPratica: boolean;
    stampaPratica: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent<HTMLElement>) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const TableUnavailabilityManagementMenu = ({
  visibility = {
    aperturaPratica: true,
    stampaPratica: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: TableUnavailabilityManagementMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  const [printUnavailabilityModal, setPrintUnavailabilityModal] = useState<boolean>(false);

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Gestione Pratica Irreperibilità" />
      </ListItem>
      <Menu
        id="table-unavailable-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.aperturaPratica
          ? [
              <MenuItem
                key="aperturaPratica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/nuova-pratica/irreperibilita');
                }}
              >
                <Typography variant="inherit">Apertura Pratica</Typography>
              </MenuItem>,
              <Divider key="aperturaPratica-divider" hidden={!visibility.stampaPratica} />,
            ]
          : undefined}
        {visibility.stampaPratica
          ? [
              <MenuItem
                key="stampaPratica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  setPrintUnavailabilityModal(true);
                }}
              >
                <Typography variant="inherit">Stampa per Prefettura</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
      <PrintUnavailability
        isOpen={printUnavailabilityModal}
        onClose={() => setPrintUnavailabilityModal(false)}
      />
    </Fragment>
  );
};

TableUnavailabilityManagementMenu.displayName = 'Table UnavailabilityManagement Menu';

export default TableUnavailabilityManagementMenu;
